// Offer action types

const offerActionTypes = {
  ADD_OFFER_CODE: 'ADD_OFFER_CODE',
  REMOVE_OFFER_CODE: 'REMOVE_OFFER_CODE',
  SET_OFFER_CODE_DESCRIPTION: 'SET_OFFER_CODE_DESCRIPTION',
  ON_OFFER_CODE_ERROR: 'ON_OFFER_CODE_ERROR',
  ADD_ACTIVE_OFFER: 'ADD_ACTIVE_OFFER',
  ADD_ACTIVE_EMAIL_OFFER: 'ADD_ACTIVE_EMAIL_OFFER',
  REMOVE_ACTIVE_OFFER: 'REMOVE_ACTIVE_OFFER',
  REMOVE_ALL_ACTIVE_OFFERS: 'REMOVE_ALL_ACTIVE_OFFERS',
  VERIFY_ACTIVE_OFFERS: 'VERIFY_ACTIVE_OFFERS',
  SET_OFFER_APPLIED_VIA_PROMO_BANNER: 'SET_OFFER_APPLIED_VIA_PROMO_BANNER'
};

export default offerActionTypes;
